import { useTranslation } from "react-i18next";
import ErrorIcon from "@mui/icons-material/Error";
import { useStyles } from "./NoData.styles";
import { INoData } from "./NoDataInterfaces";

const NoData = ({ className, title }: INoData) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={`${classes.mainWrapper} ${className ? className : ""}`}>
            <ErrorIcon className={classes.noDataIcon} />
            <div>{title ? title : t("data.no_data")}</div>
        </div>
    );
};

export default NoData;
